// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i69Lc","col":"styles_col__1vemA"};